import { Component, h } from 'preact'
import Header from '../header'
import Panel from '../panel'
import RadioInputGroup from '../ui-components/RadioInputGroup'
import SSIFooter, {SSIFooterData} from './SSIFooter'
import CustomFooter, {CustomFooterData} from './CustomFooter'
import {getCommunityFooterConfig, updateCommunityFooterConfig, CommunityFooterConfig} from '../../utils/api'
import AlertComponent from '../ui-components/AlertComponent'

interface Props {}

interface State {
  selectedOption: number,
  ssiFooter: SSIFooterData,
  customFooter: CustomFooterData,
  success?: boolean,
  error?: boolean,
  isLoading?: boolean
}

const options = [
  <div>
    <strong>Default</strong>
    <div>Use default footer</div>
  </div>,
  <div>
    <strong>Server Side Include (SSI) configuration</strong>
    <div>Include external HTML footer via URL</div>
  </div>,
  <div>
    <strong>Custom code only</strong>
    <div>Add footer via custom HTML</div>
  </div>
]

class CommunityHeader extends Component<Props, State> {
  constructor (props: Props) {
    super(props)
    this.state = {
      selectedOption: 0,
      ssiFooter: {
        url: ''
      },
      customFooter: {
        html: ''
      }
    }
  }

  async componentDidMount () {
    this.setStateFromBackend(await getCommunityFooterConfig())
  }

  setStateFromBackend (data: CommunityFooterConfig) {
    this.setState({
      selectedOption: ['default', 'ssi', 'custom'].indexOf(data.type),
      ssiFooter: data.ssiFooter,
      customFooter: data.customFooter
    })
  }

  async save () {
    this.setState({ error: false, success: false, isLoading: true })
    let type: 'default' | 'ssi' | 'custom' = 'default'
    if (this.state.selectedOption === 1) type = 'ssi'
    if (this.state.selectedOption === 2) type = 'custom'
    let updated
    try {
      updated = await updateCommunityFooterConfig({
        type: type,
        ssiFooter: this.state.ssiFooter,
        customFooter: this.state.customFooter,
      })
    } catch (err) {
      this.setState({ error: true, isLoading: false })
      return
    }

    this.setStateFromBackend(updated)
    this.setState({ success: true, isLoading: false })
  }

  render (_: Props, { selectedOption, ssiFooter, customFooter, success, error, isLoading } : State) {
    const subComponents = [
      null,
      <SSIFooter {...ssiFooter} onChange={(newData: SSIFooterData) => this.setState({
        ssiFooter: { ...this.state.ssiFooter, ...newData }
      })} />,
      <CustomFooter {...customFooter} onChange={(newData: CustomFooterData) => {
        this.setState({
          customFooter: { ...this.state.customFooter, ...newData }
        })
      }} />
    ]

    return (
      <div className='community-footer'>
        <Header
          title='Footer'
          saveCallback={() => this.save()}
          isLoading={isLoading}
        />

        {error && <AlertComponent
          messageType='error'
          message={'Could not save configuration'}
          renderHTML
          isVisibleFor={3000}
        />}

        {success && <AlertComponent
          messageType='success'
          isVisibleFor={3000}
        />}

        <Panel title='Footer type'>
          <div className='community-footer_radio-buttons'>
            <RadioInputGroup
              title=''
              options={options}
              onChange={(_: string, idx: number) => this.setState({ selectedOption: idx })}
              value={options[selectedOption]}
            />
          </div>
          {
            subComponents[selectedOption] ? (
              <div className='community-footer_sub-component'>
                {subComponents[selectedOption]}
              </div>
            ) : null
          }
        </Panel>
      </div>
    )
  }
}

export default CommunityHeader
